import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_sentryserver_4ec88b3c from 'nuxt_plugin_sentryserver_4ec88b3c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2de1cc98 from 'nuxt_plugin_sentryclient_2de1cc98' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_0409066c from 'nuxt_plugin_plugin_0409066c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_7403d5e7 from 'nuxt_plugin_recaptcha_7403d5e7' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_pluginserver_e56f1caa from 'nuxt_plugin_pluginserver_e56f1caa' // Source: ./nuxt-booster/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_278f0023 from 'nuxt_plugin_pluginclient_278f0023' // Source: ./nuxt-booster/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginutils_175109c3 from 'nuxt_plugin_pluginutils_175109c3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3d36324e from 'nuxt_plugin_pluginrouting_3d36324e' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_39228be1 from 'nuxt_plugin_pluginmain_39228be1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginsasklyscriptconnection24334d66_2877913e from 'nuxt_plugin_pluginsasklyscriptconnection24334d66_2877913e' // Source: ./plugins.askly-script-connection.24334d66.ts (mode: 'all')
import nuxt_plugin_pluginscookiebotconsentlistener60e73b00_feb892cc from 'nuxt_plugin_pluginscookiebotconsentlistener60e73b00_feb892cc' // Source: ./plugins.cookiebot-consent-listener.60e73b00.ts (mode: 'client')
import nuxt_plugin_vsfpaymentsredirectsetcartidplugin6929a2de_8d7ddc18 from 'nuxt_plugin_vsfpaymentsredirectsetcartidplugin6929a2de_8d7ddc18' // Source: ./vsf-payments-redirect.set-cart-id.plugin.6929a2de.ts (mode: 'client')
import nuxt_plugin_gtm_687def64 from 'nuxt_plugin_gtm_687def64' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuescrollto_59c8eb91 from 'nuxt_plugin_vuescrollto_59c8eb91' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_412d1754 from 'nuxt_plugin_cookieuniversalnuxt_412d1754' // Source: ./cookie-universal-nuxt.ts (mode: 'all')
import nuxt_plugin_pluginsloadmanagednewsletter236c5c75_0bb7a26e from 'nuxt_plugin_pluginsloadmanagednewsletter236c5c75_0bb7a26e' // Source: ./plugins.load-managed-newsletter.236c5c75.ts (mode: 'all')
import nuxt_plugin_pluginsloadlastviewedproductsdf5698d2_26298927 from 'nuxt_plugin_pluginsloadlastviewedproductsdf5698d2_26298927' // Source: ./plugins.load-last-viewed-products.df5698d2.ts (mode: 'all')
import nuxt_plugin_pluginsklevuplugin2e95df84_021b5096 from 'nuxt_plugin_pluginsklevuplugin2e95df84_021b5096' // Source: ./plugins.klevu.plugin.2e95df84.ts (mode: 'all')
import nuxt_plugin_clientindexd3762fe8_4a579420 from 'nuxt_plugin_clientindexd3762fe8_4a579420' // Source: ./client.index.d3762fe8.ts (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_412d19c0 from 'nuxt_plugin_cookieuniversalnuxt_412d19c0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_httpserver_5e087e65 from 'nuxt_plugin_httpserver_5e087e65' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_3c740050 from 'nuxt_plugin_http_3c740050' // Source: ./http.js (mode: 'all')
import nuxt_plugin_strapi_6771ac37 from 'nuxt_plugin_strapi_6771ac37' // Source: ./strapi.js (mode: 'all')
import nuxt_plugin_nuxtplugin50188715_338afd2a from 'nuxt_plugin_nuxtplugin50188715_338afd2a' // Source: ./nuxt.plugin.50188715.js (mode: 'server')
import nuxt_plugin_image_2bbcc073 from 'nuxt_plugin_image_2bbcc073' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin2b8990cb_4a18cd03 from 'nuxt_plugin_coreplugin2b8990cb_4a18cd03' // Source: ./core.plugin.2b8990cb.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting38f658eb_83494cac from 'nuxt_plugin_pluginse2etesting38f658eb_83494cac' // Source: ./plugins.e2e-testing.38f658eb.js (mode: 'all')
import nuxt_plugin_deviceplugin_70ee6303 from 'nuxt_plugin_deviceplugin_70ee6303' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_6c233a94 from 'nuxt_plugin_workbox_6c233a94' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_d99aa4b2 from 'nuxt_plugin_metaplugin_d99aa4b2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_distplugin57527824_268e2af4 from 'nuxt_plugin_distplugin57527824_268e2af4' // Source: ./dist.plugin.57527824.mjs (mode: 'all')
import nuxt_plugin_skipauthforssr_1776b0c1 from 'nuxt_plugin_skipauthforssr_1776b0c1' // Source: ../plugins/skip-auth-for-ssr (mode: 'server')
import nuxt_plugin_title_335c7ebc from 'nuxt_plugin_title_335c7ebc' // Source: ../plugins/title (mode: 'client')
import nuxt_plugin_routerreferer_5c08cf9f from 'nuxt_plugin_routerreferer_5c08cf9f' // Source: ../plugins/router-referer (mode: 'client')
import nuxt_plugin_prepareuser_326eb172 from 'nuxt_plugin_prepareuser_326eb172' // Source: ../plugins/prepare-user (mode: 'client')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_validators_68c66f14 from 'nuxt_plugin_validators_68c66f14' // Source: ../plugins/validators.ts (mode: 'client')
import nuxt_plugin_swipervue_731fbb26 from 'nuxt_plugin_swipervue_731fbb26' // Source: ../plugins/swiper-vue.ts (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_meta_1d50025c from 'nuxt_plugin_meta_1d50025c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"debounceWait":1000,"refreshOnceOnNavigation":true,"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"aatrium.ee","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"hid":"description","name":"description","content":"\u003C!-- ALL-CONTRIBUTORS-BADGE:START - Do not remove or modify this section --\u003E [![All Contributors](https:\u002F\u002Fimg.shields.io\u002Fbadge\u002Fall_contributors-21-orange.svg?style=flat-square)](#contributors-) \u003C!-- ALL-CONTRIBUTORS-BADGE:END --\u003E"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"DNS-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiGyp8kv8JHgFVrLPTufntAOvWDSHFF.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiGyp8kv8JHgFVrLPTucHtAOvWDSA.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiEyp8kv8JHgFVrJJnecnFHGPezSQ.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiEyp8kv8JHgFVrJJfecnFHGPc.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLGT9Z1JlFd2JQEl8qw.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLGT9Z1xlFd2JQEk.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLEj6Z1JlFd2JQEl8qw.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLEj6Z1xlFd2JQEk.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLCz7Z1JlFd2JQEl8qw.woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLCz7Z1xlFd2JQEk.woff2","crossorigin":"anonymous"}],"style":[{"type":"text\u002Fcss","cssText":"\n\u002F* latin-ext *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiGyp8kv8JHgFVrLPTufntAOvWDSHFF.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\u002F* latin *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiGyp8kv8JHgFVrLPTucHtAOvWDSA.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\u002F* latin-ext *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiEyp8kv8JHgFVrJJnecnFHGPezSQ.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\u002F* latin *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiEyp8kv8JHgFVrJJfecnFHGPc.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\u002F* latin-ext *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLGT9Z1JlFd2JQEl8qw.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\u002F* latin *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLGT9Z1xlFd2JQEk.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\u002F* latin-ext *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLEj6Z1JlFd2JQEl8qw.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\u002F* latin *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLEj6Z1xlFd2JQEk.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\u002F* latin-ext *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLCz7Z1JlFd2JQEl8qw.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\u002F* latin *\u002F\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Fpoppins\u002Fv21\u002FpxiByp8kv8JHgFVrLCz7Z1xlFd2JQEk.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n"}],"__dangerouslyDisableSanitizers":["script"],"script":[{"id":"CookiebotConnector","type":"text\u002Fjavascript","innerHTML":"\n        if( !navigator.userAgent.match(\u002F(Mozilla\\\u002F5\\.0 \\(Linux; Android 11; moto g power \\(2022\\)\\) AppleWebKit\\\u002F537\\.36 \\(KHTML, like Gecko\\) Chrome\\\u002F\\d{3}\\.0.0.0 Mobile Safari\\\u002F537\\.36)\u002F) ){\n          const el = document.createElement('script');\n           el.setAttribute('data-cbid', \"00a90a83-4eef-4053-87a0-50e854279097\");\n           el.setAttribute('defer', true);\n           el.setAttribute('async', true);\n           el.setAttribute('id', \"Cookiebot\");\n           el.src = \"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js\";\n           document.head.appendChild(el);\n        }\n        "},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-WFPJHNF')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-WFPJHNF&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4ec88b3c === 'function') {
    await nuxt_plugin_sentryserver_4ec88b3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2de1cc98 === 'function') {
    await nuxt_plugin_sentryclient_2de1cc98(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0409066c === 'function') {
    await nuxt_plugin_plugin_0409066c(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_7403d5e7 === 'function') {
    await nuxt_plugin_recaptcha_7403d5e7(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_e56f1caa === 'function') {
    await nuxt_plugin_pluginserver_e56f1caa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_278f0023 === 'function') {
    await nuxt_plugin_pluginclient_278f0023(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_175109c3 === 'function') {
    await nuxt_plugin_pluginutils_175109c3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3d36324e === 'function') {
    await nuxt_plugin_pluginrouting_3d36324e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_39228be1 === 'function') {
    await nuxt_plugin_pluginmain_39228be1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsasklyscriptconnection24334d66_2877913e === 'function') {
    await nuxt_plugin_pluginsasklyscriptconnection24334d66_2877913e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginscookiebotconsentlistener60e73b00_feb892cc === 'function') {
    await nuxt_plugin_pluginscookiebotconsentlistener60e73b00_feb892cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vsfpaymentsredirectsetcartidplugin6929a2de_8d7ddc18 === 'function') {
    await nuxt_plugin_vsfpaymentsredirectsetcartidplugin6929a2de_8d7ddc18(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_687def64 === 'function') {
    await nuxt_plugin_gtm_687def64(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_59c8eb91 === 'function') {
    await nuxt_plugin_vuescrollto_59c8eb91(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_412d1754 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_412d1754(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsloadmanagednewsletter236c5c75_0bb7a26e === 'function') {
    await nuxt_plugin_pluginsloadmanagednewsletter236c5c75_0bb7a26e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsloadlastviewedproductsdf5698d2_26298927 === 'function') {
    await nuxt_plugin_pluginsloadlastviewedproductsdf5698d2_26298927(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsklevuplugin2e95df84_021b5096 === 'function') {
    await nuxt_plugin_pluginsklevuplugin2e95df84_021b5096(app.context, inject)
  }

  if (typeof nuxt_plugin_clientindexd3762fe8_4a579420 === 'function') {
    await nuxt_plugin_clientindexd3762fe8_4a579420(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_412d19c0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_412d19c0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_5e087e65 === 'function') {
    await nuxt_plugin_httpserver_5e087e65(app.context, inject)
  }

  if (typeof nuxt_plugin_http_3c740050 === 'function') {
    await nuxt_plugin_http_3c740050(app.context, inject)
  }

  if (typeof nuxt_plugin_strapi_6771ac37 === 'function') {
    await nuxt_plugin_strapi_6771ac37(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin50188715_338afd2a === 'function') {
    await nuxt_plugin_nuxtplugin50188715_338afd2a(app.context, inject)
  }

  if (typeof nuxt_plugin_image_2bbcc073 === 'function') {
    await nuxt_plugin_image_2bbcc073(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin2b8990cb_4a18cd03 === 'function') {
    await nuxt_plugin_coreplugin2b8990cb_4a18cd03(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting38f658eb_83494cac === 'function') {
    await nuxt_plugin_pluginse2etesting38f658eb_83494cac(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_70ee6303 === 'function') {
    await nuxt_plugin_deviceplugin_70ee6303(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6c233a94 === 'function') {
    await nuxt_plugin_workbox_6c233a94(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_d99aa4b2 === 'function') {
    await nuxt_plugin_metaplugin_d99aa4b2(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin57527824_268e2af4 === 'function') {
    await nuxt_plugin_distplugin57527824_268e2af4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_skipauthforssr_1776b0c1 === 'function') {
    await nuxt_plugin_skipauthforssr_1776b0c1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_title_335c7ebc === 'function') {
    await nuxt_plugin_title_335c7ebc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routerreferer_5c08cf9f === 'function') {
    await nuxt_plugin_routerreferer_5c08cf9f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_prepareuser_326eb172 === 'function') {
    await nuxt_plugin_prepareuser_326eb172(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_validators_68c66f14 === 'function') {
    await nuxt_plugin_validators_68c66f14(app.context, inject)
  }

  if (typeof nuxt_plugin_swipervue_731fbb26 === 'function') {
    await nuxt_plugin_swipervue_731fbb26(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_1d50025c === 'function') {
    await nuxt_plugin_meta_1d50025c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
